module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/point_maedori_01@2x-fc5ba9abecb11b4df583f3a6215ef7f6.webp";